import { Injectable } from '@angular/core';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { InstructorCoachPromoComponent } from './instructor-coach-promo.component';
import { RolesService } from '@app/core/services/roles/roles.service';
import { CustomService } from '@app/core/services/drupal8';
import { LocalStorageService } from '@app/core/services/localstorage/localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class InstructorCoachPromoService {
  private readonly storageKey = 'coach_promo';
  private hasToSave = false;
  private modalRef?: NgbModalRef;
  constructor(
    private modalService: NgbModal,
    private roleService: RolesService,
    private customService: CustomService,
    private localStorageService: LocalStorageService
  ) {
    this.customService.startAfterLogout$.subscribe(() => this.checkToPersist());
    this.customService.endAfterLogout$.subscribe(() => this.fixPersist());
  }

  open(force = false): void {
    if (this.shouldOpenIt() || force) {
      const options = { size: 'xl', modalDialogClass: 'bg-transparent promo-coach modal-dialog-centered' };
      this.modalRef = this.modalService.open(InstructorCoachPromoComponent, options);
      this.modalRef.componentInstance.service = this;
    }
  }

  close(): void {
    this.modalRef?.dismiss();
    this.saveClose();
  }

  private saveClose(): void {
    this.localStorageService.setItem(this.storageKey, 'done');
  }

  private shouldOpenIt(): boolean {
    if (this.localStorageService.getItem(this.storageKey) !== null) {
      return false;
    }
    if (!this.roleService.userHasRole('instructor_level', true)) {
      return false;
    }
    return true;
  }
  private checkToPersist(): void {
    this.hasToSave = this.localStorageService.getItem(this.storageKey) !== null;
  }

  private fixPersist(): void {
    if (!this.hasToSave) {
      return;
    }
    this.saveClose();
    this.hasToSave = false;
  }
}
